import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from './reducers/authReducer';
import userReducer from './reducers/userReducer';
import packageReducer from './reducers/packageReducer';
import deliveryReducer from './reducers/deliveryReducer';
import transactionReducer from './reducers/transactionReducer';
import reviewReducer from './reducers/reviewReducer';
import faqReducer from './reducers/faqReducer';
import helpTopicReducer from './reducers/helpTopicReducer';
import chatReducer from './reducers/chatReducer';
import notificationReducer from './reducers/notificationReducer';
import analyticsReducer from './reducers/analyticsReducer';
import commissionReducer from './reducers/driverCommissionReducer'; 
import termsAndPoliciesReducer from './reducers/termsAndpoliciesReducer';
import contactSupportReducer from './reducers/contactSupportReeducer';
import vehicleReducer from './reducers/vehicleReducer';
import businessReducer from './reducers/businessReducer';
import driverReducer from './reducers/driverReducer';
import privacySettingsReducer from './reducers/privacySettingsReducer';
import bankDetailsReducer from './reducers/bankDetailsReducer';
import packagePlanReducer from './reducers/planReducer';
import rateReducer from './reducers/rateReducer';
import paymentProofReducer from './reducers/paymentProofReducer';
import companySettingsReducer from './reducers/companySettingsReducer';
import packageEvidenceReducer from './reducers/packageEvidenceReducer';
import protectionTierReducer from './reducers/protectionTierReducer';
import claimReducer from './reducers/claimReducer';
import appVersionReducer from './reducers/appVersionReducer';

// Combine reducers if there are multiple reducers
const rootReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  packages: packageReducer, 
  deliveries: deliveryReducer,
  transactions: transactionReducer,
  reviews: reviewReducer,
  faqs: faqReducer,
  helpTopics: helpTopicReducer,
  chat: chatReducer, 
  notifications: notificationReducer,
  analytics: analyticsReducer,
  commissions: commissionReducer,
  terms: termsAndPoliciesReducer,
  supportMessages: contactSupportReducer,
  vehicles: vehicleReducer,
  businesses: businessReducer,
  drivers: driverReducer,
  privacySettings: privacySettingsReducer,
  bank: bankDetailsReducer,
  plans: packagePlanReducer,
  rates: rateReducer,
  proofs: paymentProofReducer,
  companySettings: companySettingsReducer,
  packageEvidence: packageEvidenceReducer,
  protectionTiers: protectionTierReducer,
  claims: claimReducer,
  appVersions: appVersionReducer,
});

// Create Redux store with middleware
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
